import { UMIcon, UMSelect, UMR } from '../../../urbanmap/_components';
import type { NetworkDisplay } from './networkDisplay';

/** Local UMSelect adapter: the measured 26px grey UMTag used by Couches ("Conso. chaud ▾"). */
export function LegendSelect({ value, hasDensity, onChange }: {
  value: NetworkDisplay; hasDensity: boolean; onChange: (value: NetworkDisplay) => void;
}) {
  // Shrink-wrapped so the arrow sits inside the tag (4px text gap, 16px icon, 4px padding).
  return <div data-network-legend-select="" style={{ position: 'relative', display: 'inline-flex', maxWidth: '100%' }}>
    <style>{`
      [data-network-legend-select] select {
        width:auto!important;max-width:100%;height:26px!important;border-radius:0!important;
        padding:4px 24px 4px 4px!important;background:${UMR.tagBg}!important;
        border:1px solid ${UMR.borderInput}!important;
        font:14px/16px ${UMR.font}!important;color:${UMR.black}!important;
      }
      [data-network-legend-select] select + span {display:none!important}
    `}</style>
    <UMSelect ariaLabel="Mode de légende des canalisations" value={hasDensity ? value : 'pipes'}
      options={[{ value: 'pipes', label: 'Uniforme' },
        ...(hasDensity ? [{ value: 'density', label: 'Densité linéaire' }] : [])]}
      onChange={next => { if (next === 'pipes' || (next === 'density' && hasDensity)) onChange(next); }} />
    <span style={{ position: 'absolute', right: 4, top: 5, display: 'flex', pointerEvents: 'none' }}>
      <UMIcon name="arrow_drop_down" family="icons" size={16} color={UMR.black} />
    </span>
  </div>;
}
